<template>
    <div>
        <form class="forms-sample" style="padding-left: 1rem;">
            {{getOrganizationSettings}}
            <!-- <h5 class=" sub-title mb-3 text-primary">{{ formHeader }}</h5> -->
            <div class="form-group row">
                <!-- title input -->
                <ul style="list-style: none;">
                    
                    <div class="col-md-12" style="padding-left: 0px;">
                        <li>
                            <div class="col-md-12" style="padding-left: 0px; color: #48a6a6;">
                                <!-- <ul>
                                    <li> -->
                                        <label>Limit the number of driver users</label>
                                    <!-- </li>
                                </ul>         -->
                            </div>
                            <div class="col-md-6" style="padding-left: 0px;">
                                <input type="number" class="form-control" id="limit_driver_users"
                                    v-model="limit_driver_users" min="1" value="" required>
                            </div>
                        </li>
                    </div>
                    
                    <div class="col-md-12" style="padding-left: 0px;">
                        <li>
                            <div class="col-md-12" style="padding-left: 0px; color: #48a6a6;">
                                <label>Allow this organization to send SMS.</label>
                            </div>
                            <div class="col-md-6" style="padding-left: 0px;">
                                <input type="radio" value="1" id="send_sms_to_contacts"
                                    v-model="send_sms_to_contacts">&nbsp;Yes
                                &nbsp;&nbsp;
                                <input type="radio" value="0" id="send_sms_to_contacts"
                                    v-model="send_sms_to_contacts">&nbsp;No
                            </div>
                        </li>
                    </div>
                 </ul>   
            </div>
            <!-- <div class="form-group row" v-if=" pageForm.status == 'trial'">
                <!-- title input -->
               <!-- <div class="col-md-12">

                    <h5 class=" sub-title mb-3 text-primary">Trial Peroid Dates:</h5>
                </div>
                <div class="col-md-6">
                    <div class="col-md-6">
                        <label>Start Date:</label>
                    </div>
                    <div class="col-md-6">
                        <input id="start_date" v-model="pageForm.start_date" class="form-control" format="MM/dd/yyyy"
                            type="date" value=" " required>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="col-md-6">
                        <label> End Date:</label>
                    </div>
                    <div class="col-md-6">
                        <input id="end_date" v-model="pageForm.end_date" class="form-control" format="MM/dd/yyyy"
                            type="date" value=" " required>
                    </div>
                </div>

            </div> -->

            <div class="text-right">
                <button class="btn btn-primary" @click.prevent="saveSettings">Save</button>
            </div>
        </form>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        props:["formData"],
        data: function () {
            return {
                formHeader: '',
                limit_driver_users:'',
                send_sms_to_contacts:"",
                flag:true,
                pageForm: {},
            };
        },
        created: function(){
             this.send_sms_to_contacts = "";
        },
         computed:  {
        //     this.formHeader = 'Organization Settings';
            getOrganizationSettings: function (){
                axios.get('admin/organization/settings/' + this.formData.org_id)
                    .then((response) => {
                    let res = response.data.data;
                    if (res != null) {
                        this.limit_driver_users = res.limit_driver_users;
                        this.send_sms_to_contacts = res.send_sms_to_contacts;
                    }else{
                        
                        this.limit_driver_users = "";
                        this.send_sms_to_contacts = "";
                    }
                    this.flag = true;
                });
            },
        },
        methods: {
            // Getting settings of current organization
            

            // Upload Document against an organization
            saveSettings() {
                // Show warning message if Title or document is not given
                let formData = new FormData();
                formData.append('organization_id', this.formData.org_id);
                formData.append('limit_driver_users', this.limit_driver_users);
                formData.append('send_sms_to_contacts', this.send_sms_to_contacts);
                // formData.append('start_date', this.pageForm.start_date);
                // formData.append('end_date', this.pageForm.end_date);

                // if (this.pageForm.start_date >= this.pageForm.end_date) {
                //     this.$toast.warning('Trial end date cannot be less than trial start date.');
                // }
                // else {
                    axios.post('/admin/organization/settings', formData, {})
                        .then((response) => {
                            // send successful message
                            this.$toast.success(response.data.message);
                            window.$('#modal').modal('hide');
                        })
                        .catch((error) => {
                        
                            this.$toast.warning("Fill Both Fields");
                            
                            // this.isMiniLoading = false;
                        });

                // }
            },
        }
    }
</script>